import React, { useContext } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Box, useTheme } from '@mui/material';
import { FreedomScroll } from '../FreedomScroll/FreedomScroll';
import { ColorModeContext } from '../../../store';
import FreedomScrollBar from '../FreedomScrollBar/FreedomScrollBar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { appInsights } from '../../../auth/appInsight';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

// type GradientProps = {
//   gradientColors: string[];
// };
// const options = {
//   shouldForwardProp: (prop) => prop !== 'gradientColors'
// };

// const borderRadius = 15;
// const Boxx = styled(
//   Box,
//   options
// )(({ theme, gradientColors, padding }) => ({
//   position: 'relative',
//   //   border: "0px solid transparent",
//   backgroundClip: 'padding-box',
//   borderRadius,
//   padding: padding || '15px 16px',
//   // minWidth: '350px',
//   // minHeight: '400px',
//   // height: '100%',
//   // maxHeight: '400px',
//   // overflowY: 'scroll',
//   // overflowX: 'hidden',
//   // '&::-webkit-scrollbar': {
//   // 	display: 'none'
//   // },

//   '&:after': {
//     position: 'absolute',
//     top: -2,
//     left: -2,
//     right: -2,
//     bottom: 2,
//     background: `linear-gradient(to bottom, ${gradientColors.join(',')})`,
//     content: '""',
//     zIndex: -1,
//     borderRadius
//   }
// }));

const AffiliateCardBackground = styled('div')(({ theme, height, simple, marginTop, border, bg, padding, marginBottom }) => ({
  background: bg ? theme.palette.background.default : '',
  borderRadius: '10px',
  padding: padding || '10px 16px',
  marginTop: marginTop || '10px',
  border: `2px solid ${theme.palette.border.containerborder}`,
  // cursor: simple ? "" : "pointer",
  width: '100%',
  height: height || '100%',
  display: 'flex',
  alignItems: 'center',
  marginBottom: marginBottom || '0px',
  [theme.breakpoints.down('md')]: {
    padding: '10.27px 5.29px',
    borderRadius: '5px'
  },
  [theme.breakpoints.up('xll')]: {
    borderRadius: getStringProduct(1.25, '10px'),
    padding: getStringProduct(1.25, padding || '10px 16px'),
    marginTop: getStringProduct(1.25, marginTop || '10px'),
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.25, height),
    marginBottom: getStringProduct(1.25, marginBottom || '0px')
  },
  [theme.breakpoints.up('xlll')]: {
    borderRadius: getStringProduct(1.66, '10px'),
    padding: getStringProduct(1.66, padding || '10px 16px'),
    marginTop: getStringProduct(1.66, marginTop || '10px'),
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.66, height),
    marginBottom: getStringProduct(1.66, marginBottom || '0px')
  },
  [theme.breakpoints.up('xl4')]: {
    borderRadius: getStringProduct(2.46, '10px'),
    padding: getStringProduct(2.46, padding || '10px 16px'),
    marginTop: getStringProduct(2.46, marginTop || '10px'),
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(2.46, height),
    marginBottom: getStringProduct(2.46, marginBottom || '0px')
  }
}));

const FreedomWrapperRoot = ({ children, table = 'false', marginTop = '50px', height = '48', padding, perfectScroll = false, border = true, bg = true, marginBottom = '0px', width = '100%', ...props }) => {
  const theme = useTheme();
  const {
    colorMode: { toggleMode, mode }
  } = useContext(ColorModeContext);
  try {
    return (
      <AffiliateCardBackground padding={padding} marginTop={marginTop} border={border} bg={bg} {...props}>
        {table === 'true' ? children : perfectScroll === false ? <FreedomScroll height={height}>{children}</FreedomScroll> : <PerfectScrollbar style={{ height: `${height}vh`, width: width }}>{children}</PerfectScrollbar>}
      </AffiliateCardBackground>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomWrapperRoot;
